module.exports = __webpack_public_path__ + "static/img/study_report_official.3c1ae8d9.png";